import { IClientConfig } from "src/client-config/config";
import { PriceChangeEnum } from "src/constants/enums/priceChange";
import { ISelection } from "src/constants/interfaces/bet";
import { IMainStore } from "src/stores/main";
import { IUpperDataStore } from "src/stores/upperData";

export const getMinStake = (config: IClientConfig, upperData: IUpperDataStore) => {
  if (config.restrictions?.minBetStake) return config.restrictions.minBetStake;

  const currency = upperData.currencyConfig?.name;
  const minStake = currency ? upperData.partnerConfig?.min_bet_stakes?.[currency] : 0;

  return minStake;
};

export const getOfferMinStake = (config: IClientConfig, upperData: IUpperDataStore) => (
  upperData?.partnerConfig?.minimum_offer_amount || getMinStake(config, upperData)
);

export const getBetMinStake = (
  config: IClientConfig,
  selections: ISelection[],
  mainState: IMainStore,
  upperData: IUpperDataStore,
) => {
  const isOffer = selections.some(item => item.priceChangeType === PriceChangeEnum.CounterOffer);
  return isOffer ? getOfferMinStake(config, upperData) : getMinStake(config, upperData);
};

export const getBetMaxStake = (config: IClientConfig, mainState: IMainStore) => {
  if (config.restrictions?.maxBetStake || config.restrictions?.maxBetStake === 0)
    return config.restrictions.maxBetStake;

  return mainState.maxStake;
};